module.exports = __webpack_public_path__ + "img/0.6d307128.png";